module.exports = __webpack_public_path__ + "6bf572356b98ff014bbec96a752197c6.png";